/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-01-07",
    versionChannel: "nightly",
    buildDate: "2024-01-07T00:15:31.560Z",
    commitHash: "f0ed5c7211c22eda87425456e04e4d665068fa21",
};
